import { lazy } from 'react'

export const LandingPage = lazy(() => import('./LandingPage'))
export const Main = lazy(() => import('./Main'))
export const Home = lazy(() => import('./home'))
export const More = lazy(() => import('./more'))
export const Service = lazy(() => import('./service'))
export const Store = lazy(() => import('./store'))
export const test = lazy(() => import('./testComponenet'))
export const PlanDetails = lazy(() => import('./planDetails'))
export const PayBills = lazy(() => import('./PayBills'))
export const InsatllmentDetails = lazy(() => import('./PayBills/fixedLineBills/insatllmentDetails'))
export const BillsDetailsPage = lazy(() => import('./PayBills/billsDetails'))
export const RechargeBalance = lazy(() => import('./rechargeBalance'))
export const BundleDetailsPage = lazy(() =>
  import('./home/bundleSection/bundlePage/bundleDetailsPage')
)
export const OfferDetailsPage = lazy(() =>
  import('./home/hotOffers/offerDetails')
)
export const UsageDetailsPage = lazy(() =>
  import('./quickAccess/Usage/usageDetailsComponent')
)
export const AllOffersPage = lazy(() => import('./home/hotOffers/allOffers'))
export const CampaignOfferNoGiftsPage = lazy(() =>
  import('./home/hotOffers/campaignOfferNoGifts')
)
export const CampaignOfferGiftsPage = lazy(() =>
  import('./home/hotOffers/campaignOfferGifts')
)

export const JPCallBack = lazy(() =>
  import('./../components/paymentType/JPCallBack')
)
export const profile = lazy(() => import('./profile'))
export const AddReflectInfo = lazy(() => import('./profile/addReflectInfo'))
export const TransactionHistory = lazy(() =>
  import('./more/transactionHistory')
)
export const MyBills = lazy(() => import('./PayBills/myBills'))
export const SwitchNumbers = lazy(() => import('./more/numberManagement'))
export const CardsManagement = lazy(() => import('./more/cardsManagement'))
export const usage = lazy(() => import('./quickAccess/Usage'))
export const quickAccess = lazy(() => import('./quickAccess/QuickAccess'))
export const devices = lazy(() => import('./PayBills/handsetInstallmentsPage'))
export const BundleAndOfferPage = lazy(() =>
  import('./service/bundleAndOfferPage')
)
export const InternationalRoaming = lazy(() =>
  import('./service/roamingService/InternationalRoaming')
)
export const CountryInfoPage = lazy(() =>
  import('./service/roamingService/countryInfoPage')
)
export const TipsPage = lazy(() =>
  import('./service/roamingService/tipsComponent')
)
export const MCNPage = lazy(() => import('./service/MCN'))
export const VasService = lazy(() =>
  import('./service/otherService/vasService')
)
export const TransferBalance = lazy(() =>
  import('./service/otherService/transferBalance')
)
export const SelectedNumber = lazy(() =>
  import('./service/otherService/selectedNumber')
)
export const selectYourNumber = lazy(() =>
  import('./service/otherService/selectYourNumber')
)
export const simSwap = lazy(() => import('./service/otherService/simSwap'))
export const giftSharing = lazy(() => import('./service/giftSharing'))
export const selectGift = lazy(() => import('./service/giftSharing/selectGift'))
export const Gifts = lazy(() => import('./service/gifts'))
export const termsAndConditions = lazy(() =>
  import('./service/giftSharing/termsAndConditions')
)
export const microLoans = lazy(() => import('./service/microLoans'))
export const Maddedha = lazy(() => import('./service/maddedha'))
export const SIMPUKCode = lazy(() => import('./service/SIMPUKCode'))
export const BaringCalls = lazy(() => import('./service/baringCalls'))

export const callMeBack = lazy(() => import('./service/callMeBack'))
export const balanceHistory = lazy(() => import('./service/balanceHistory'))
export const safeInternetPage = lazy(() => import('./service/safeInternet'))
export const connectYourLine = lazy(() => import('./service/connectYourLine'))
export const RecurringPayment = lazy(() => import('./service/recurringPayment'))
export const RecurringPaymentTerms = lazy(() =>
  import('./service/recurringPayment/TermsAndConditions')
)
export const temporaryDeactivation = lazy(() =>
  import('./service/temporaryDeactivationAndReconnect')
)
export const ZerosServicePage = lazy(() => import('./service/zerosService'))
export const MobileZeros = lazy(() =>
  import('./service/zerosService/mobileZeros')
)
export const InternationalZeros = lazy(() =>
  import('./service/zerosService/internationalZeros')
)
export const FixedLinesServicesPage = lazy(() =>
  import('./service/fixedLine/fixedLineServices')
)
export const ChangeLocationPage = lazy(() =>
  import('./service/fixedLine/fixedLineServices/fixedLineChangeLocation')
)
export const ChangeNumberPage = lazy(() =>
  import('./service/fixedLine/fixedLineServices/fixedLineChangeNumber')
)
export const BillServicesPage = lazy(() => import('./service/billServices'))
export const EBillPage = lazy(() => import('./service/billServices/e-bill'))
export const BillviaSMS = lazy(() =>
  import('./service/billServices/billViaSMS')
)
export const ServiceDetails = lazy(() => import('./service/serviceDetails'))
export const PaltelBook = lazy(() => import('./service/paltelBook'))
export const ChangeLocationTermsAndConditions = lazy(() =>
  import('./service/fixedLine/fixedLineServices/changeLocationTC')
)
export const UberPage = lazy(() => import('./service/uberService'))
export const OrderTracking = lazy(() => import('./service/orderTracking'))
export const OrderTrackingDetails = lazy(() =>
  import('./service/orderTracking/details')
)
export const FixedFollowUpRouter = lazy(() =>
  import('./service/orderTracking/fixedFollowUpRouter')
)
export const Points = lazy(() => import('./service/points'))
export const NewSubscriptionRequest = lazy(() =>
  import('./service/newSubscriptionRequest/newSubscriptionRequest')
)
export const OtpVerification = lazy(() =>
  import('./service/newSubscriptionRequest')
)
export const NewSubscriptionRequestMap = lazy(() =>
  import('./service/newSubscriptionRequest/map')
)
export const AboutApp = lazy(() => import('./more/aboutApp'))
export const JawwalApps = lazy(() => import('./more/jawwalApps'))
export const Settings = lazy(() => import('./more/settings'))
export const Share = lazy(() => import('./more/share'))
export const SupportAndHelp = lazy(() => import('./more/supportAndHelp/index'))
export const CallUsPage = lazy(() => import('./more/supportAndHelp/callUs'))
export const FollowUpPage = lazy(() => import('./more/supportAndHelp/followUp'))
export const RatingPage = lazy(() => import('./more/supportAndHelp/rating'))
export const ShowRoomsPage = lazy(() =>
  import('./more/supportAndHelp/Showrooms')
)
export const SupportAndHelpIframePage = lazy(() =>
  import('./more/supportAndHelp/iframePage')
)
export const TroubleTicketPage = lazy(() =>
  import('./more/supportAndHelp/troubleTicket')
)
export const TermsAndCondition = lazy(() => import('./more/termsAndConditions'))
export const MainCorporate = lazy(() => import('./corporatePage/mainCorporate'))
export const PaltelMainCorporate = lazy(() =>
  import('./corporatePage/paltelCorporate/paltelMainCorporate')
)
export const PaltelSubscribersPage = lazy(() =>
  import('./corporatePage/paltelCorporate/paltelSubscribers')
)
export const PaltelAccountInfo = lazy(() =>
  import('./corporatePage/paltelCorporate/paltelAccountInfo')
)
export const AddTroubleTicketFixedLine = lazy(() =>
  import(
    './corporatePage/paltelCorporate/troubleTicket/addTroubleTicketFixedLine'
  )
)
export const AddTroubleTicketDataIP = lazy(() =>
  import('./corporatePage/paltelCorporate/troubleTicket/addTroubleTicketDataIP')
)
export const PaltelOrders = lazy(() =>
  import('./corporatePage/paltelCorporate/services/paltelOrders')
)

export const InvoiceDetails = lazy(() =>
  import('./corporatePage/paltelCorporate/invoices/invoicesDetails')
)

export const MainCorporatePage = lazy(() =>
  import('./corporatePage/mainCorporatePage')
)

export const SubAccountPage = lazy(() =>
  import('./corporatePage/subRootContainerPage')
)
export const SubscribersPage = lazy(() =>
  import('./corporatePage/subscribersPage')
)
export const NumberDetails = lazy(() => import('./corporatePage/numberDetails'))
export const Orders = lazy(() => import('./corporatePage/orders'))
export const AddFollowUp = lazy(() =>
  import('./corporatePage/tabComponent/AddFollowUpPage')
)
export const ServiceFiltrationPage = lazy(() =>
  import('./corporatePage/servicePages/commonServicePage')
)
export const CorporateLineService = lazy(() =>
  import('./corporatePage/servicePages/lineService')
)
export const SwipeSim = lazy(() =>
  import('./corporatePage/servicePages/swipeSim')
)
export const CorporateTempDeactivateAndReconnect = lazy(() =>
  import('./corporatePage/servicePages/tempDeactiveAndReconnect')
)
export const IndividualServicePage = lazy(() =>
  import('./corporatePage/servicePages/individualServicePage')
)
export const FreeMessages = lazy(() => import('./quickAccess/freeSMS'))
export const DeviceManagement = lazy(() => import('./more/deviceManagement'))
export const SpeedUpgradeADSL = lazy(() => import('./service/fixedLine/speedUpgrade'))
export const SpeedUpgradeSummary = lazy(() =>
  import('./service/fixedLine/speedUpgrade/speedUpgradeSummary')
)
export const TermsAndConditions = lazy(() =>
  import('./service/fixedLine/speedUpgrade/speedUpgradeTermsAndCond')
)
export const Fiber= lazy(() => import('./service/fixedLine/fiberMigration/index'))

export const FiberMigrationTermsConditions = lazy(() =>
  import('./service/fixedLine/fiberMigration/fiberMigrationTC')
)
export const SuperfastInternet = lazy(() => import('./service/fixedLine/superfastInternet'))
export const SuperfastInternetAddOns = lazy(() =>
  import('./service/fixedLine/superfastInternet/superfastAddOns')
)
export const SuperfastInternetSummary = lazy(() =>
  import('./service/fixedLine/superfastInternet/summary')
)
export const RamadanOffers = lazy(() =>
  import('./service/ramadanOffers')
)
export const RamadanBundlesBalances = lazy(() =>
  import('./service/ramadanOffers/ramadanBundlesBalancesPage')
)
export const CampaignDetails = lazy(() =>
  import('./service/ramadanOffers/campaignDetails')
)
export const LineInstallmentPage = lazy(() =>
  import('./corporatePage/servicePages/lineInstallmentPage')
)
export const DirectDebt = lazy (()=>
  import ('./service/directDebt')
)

export const DirectDebtServicePage = lazy(()=>
  import ('./corporatePage/commonServices/directDebt/directDebtServicePage')
)

export const PaltelInstallations = lazy(()=>
  import ('./corporatePage/paltelCorporate/installations/paltelInstallations')
)

export const RouterSettings = lazy(()=> import('./service/routerSettings'))

export const BundleGifting = lazy(()=>
  import ('./service/bundleGifting')
)

export const PayBillsOthers = lazy(()=>
  import ('./service/payBillsForOthers')
)

export const FiberTool = lazy(() => import('./service/fiberTool'))
export const FamilyRoaming = lazy(() => import('./service/roamingService/FamilyRoaming'))
export const CountrySelectionPage = lazy(() => import('./service/roamingService/CountrySelectionPage'))
export const FamilyRoamingSummary = lazy(() => import('./service/roamingService/FamilyRoamingSummary'))

